import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://lxsyvovevqscgzqdoqlo.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imx4c3l2b3ZldnFzY2d6cWRvcWxvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjUxNjgyNTYsImV4cCI6MjA4MDc0NDI1Nn0.N9i7hstKywiLXmfMa1jzOl24ICTgijjeEYprnMmF-f8';

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
    storage: window.localStorage,
    storageKey: 'ibv-wealth-club-auth'
  }
});
